import Layout from '@/layout'

const route = {
  path: '/taobaoLink',
  component: Layout,
  redirect: '/taobaoLink/index',
  alwaysShow: true, // will always show the root menu
  name: 'taobaoLink',
  meta: {
    title: '淘宝链接回传',
    icon: 'TLM',
    roles: [
      'tao_bao_link.managemnet'
    ]
  },
  children: [
    // 图表分析
    {
      path: '/taobaoLink/linkconfig/index',
      component: () => import('@/views/taobaoLink/linkconfig/index.vue'),
      name: 'linkconfig',
      meta: {
        title: '链接配置',
        icon: 'component',
        roles: [
          'link_config.index'
        ]
      }
    }
  ]
}

export default route
